'use client'

import { useEffect, useRef, useState } from 'react'

import { useSettings } from '@core/hooks/useSettings'

type LogoProps = {
  size?: 'small' | 'medium' | 'large'
}

const Logo = ({ size = 'medium' }: LogoProps) => {
  const logoTextRef = useRef<HTMLSpanElement>(null)

  const { settings } = useSettings()
  const [imageFull, setImageFull] = useState<boolean>(true)

  const { layout } = settings

  useEffect(() => {
    if (layout !== 'collapsed') {
      if (logoTextRef && logoTextRef.current) {
        logoTextRef.current.classList.remove('hidden')
        setImageFull(true)
      }

      return
    }

    if (logoTextRef && logoTextRef.current) {
      if (layout === 'collapsed') {
        logoTextRef.current?.classList.add('hidden')
        setImageFull(false)
      } else {
        logoTextRef.current.classList.remove('hidden')
        setImageFull(true)
      }
    }
  }, [layout])
  useEffect(() => {
    if (layout == 'collapsed') {
      if (logoTextRef && logoTextRef.current) {
        logoTextRef.current?.classList.add('hidden')
        setImageFull(false)
      }
    }
  }, [logoTextRef.current, layout])

  return (
    <div className='flex flex-col items-center min-bs-[24px]'>
      {imageFull ? (
        <img
          src='/images/icon/logo.png'
          alt='logo'
          width={size === 'large' ? 160 : size === 'small' ? 80 : 130}
          height={size === 'large' ? 110 : size === 'small' ? 50 : 90}
          style={{ objectFit: 'contain' }}
        />
      ) : (
        <img src='/images/icon/logo.png' alt='logo' width={45} height={45} style={{ objectFit: 'contain' }} />
      )}
    </div>
  )
}

export default Logo
